import React, { Component } from 'react';

import { YesNoDialog } from 'Components';

class WithdrawDialog extends Component {
  render() {
    const { student, shown, onConfirm, onCancel } = this.props;
    const {
      FirstName,
      LastName,
      Id,
      IsLastStudentOnApp,
      IsAppSelectedForVerification,
    } = student;

    if (!student) {
      return null;
    }

    var question = `Are you sure you want to WITHDRAW Stu#- ${Id}?`;

    if (IsLastStudentOnApp && IsAppSelectedForVerification) {
      question = (
        <span>
          {question}
          <br /> {FirstName} is the last student on an application selected for
          Verification. If withdrawn, their application will be removed from
          Verification and another application will be selected. This process
          may take several minutes.
        </span>
      );
    }

    return (
      <YesNoDialog
        showDialog={shown}
        title={`Withdraw - ${FirstName} ${LastName}`}
        question={question}
        yesCallback={onConfirm}
        noCallback={onCancel}
      />
    );
  }
}

export { WithdrawDialog };



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/WithdrawDialog.js